/// <reference path="../../ng-services/chat.service.ts"/>

import { LightboxItem } from '../../ng-services/lightbox.service';

(function () {
    class LightboxVideoComponent {
        public item!: LightboxItem;

        $onInit() {
            console.log('item', this.item);
        }
    }

    angular.module('tradersyard').component('tyLightboxVideo', {
        template: `<video class="lightbox_video" controls muted ng-src="{{$ctrl.item.download_url}}"></video>`,
        controller: LightboxVideoComponent,
        bindings: {
            item: '<',
        },
    });
})();
